export default __webpack_public_path__ + "static/media/ap-fatturato.7a10fe0e.svg";